var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeGestor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#D5F7F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0692 33.0627H28.389C28.1765 33.0627 27.9834 33.1979 27.9158 33.4103C26.6412 37.2922 23.0683 39.8705 19.0029 39.8705C18.9546 39.8705 18.8967 39.8705 18.8484 39.8705C13.7981 39.7932 9.65551 35.612 9.61689 30.5617C9.59758 28.0414 10.5632 25.6755 12.34 23.8794C14.1168 22.0833 16.4826 21.0984 19.0029 21.0984H30.5037C30.7838 21.0984 31.0059 20.8763 31.0059 20.5963V18.9836C31.0059 18.7036 30.7838 18.4815 30.5037 18.4815H19.1091C15.9129 18.4815 12.8904 19.7368 10.5825 22.0061C8.27465 24.285 7.00966 27.2882 7 30.4748C7 33.6807 8.24568 36.6935 10.5149 38.9628C12.7842 41.232 15.797 42.4874 18.9933 42.4874C21.6681 42.4874 24.1981 41.6279 26.3128 39.996C28.36 38.4124 29.8664 36.1817 30.5617 33.7097C30.6003 33.5552 30.5713 33.4007 30.4748 33.2751C30.3782 33.1399 30.2333 33.0627 30.0692 33.0627Z",
    fill: "url(#paint0_linear_1366_17452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0912 14.503C41.4925 13.0546 40.6234 11.7413 39.5129 10.6212C37.2243 8.29396 34.1922 7.00966 30.9766 7C30.967 7 30.967 7 30.9573 7C25.5594 7 20.7891 10.6308 19.3599 15.8356C19.3213 15.9901 19.3503 16.1446 19.4468 16.2798C19.5434 16.4053 19.6883 16.4729 19.8428 16.4729H21.5326C21.7547 16.4729 21.9382 16.3378 22.0058 16.1253C23.2708 12.2145 26.863 9.61689 30.9573 9.61689C31.0056 9.61689 31.0539 9.61689 31.1021 9.61689C36.278 9.69414 40.4399 13.9719 40.3723 19.1478C40.3047 24.2657 36.0849 28.4372 30.967 28.4372H19.4372C19.1572 28.4372 18.9351 28.6593 18.9351 28.9394V30.552C18.9351 30.832 19.1572 31.0541 19.4372 31.0541H30.967C34.1439 31.0541 37.1374 29.8278 39.4067 27.5875C41.6759 25.3568 42.9506 22.3827 42.9989 19.2154C43.0182 17.5931 42.7188 16.0094 42.0912 14.503Z",
    fill: "url(#paint1_linear_1366_17452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1366_17452",
    x1: 16.2184,
    y1: 37.1857,
    x2: 35.2752,
    y2: -8.70099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0145945,
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0935566,
    stopColor: "#5FA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#3D6A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    stopColor: "#253B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#161F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10142D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1366_17452",
    x1: 22.3666,
    y1: 39.7391,
    x2: 41.4234,
    y2: -6.14754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0145945,
    stopColor: "#68BAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0935566,
    stopColor: "#5FA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4101,
    stopColor: "#3D6A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    stopColor: "#253B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#161F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10142D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeGestor);
export default __webpack_public_path__ + "static/media/icone_gestor.e6192c48e9aecb88a283451f80cc2225.svg";
export { ForwardRef as ReactComponent };